import styled from "@emotion/styled";
import { themes } from "../../../../styles/theme";
import { ProfileActionsContent } from "./elements/ProfileActionsContent";
import { forwardRef } from "react";

interface ProfileActionsProps {
  isVisible: boolean;
  closeDisplay: () => void;
}

export const ProfileActions = forwardRef<HTMLDivElement, ProfileActionsProps>(
  ({ isVisible, closeDisplay }, ref) => {
    if (!isVisible) {
      return null;
    }

    return (
      <ProfileActionsContainer ref={ref}>
        <ProfileActionsContent closeDisplay={closeDisplay} />
      </ProfileActionsContainer>
    );
  }
);

// Sub-components

const ProfileActionsContainer = styled.div`
  width: 250px;
  position: absolute;
  background-color: ${themes.dark.surface.alt.secondary.default};
  color: ${themes.dark.font.primary.default};
  border-radius: 20px;
  padding: 8px;
  left: 86px;
  top: 20px;
  opacity: 0.5;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
  z-index: 10;
  animation: slide 0.25s ease-in-out forwards;

  @keyframes slide {
    100% {
      top: 0;
      opacity: 1;
    }
  }
`;
